<template>
  <solution-sheet-item :title="$t('Acumulação de neve')">
    <table class="solution_sheet__item__val_table">
      <tr>
        <td>S1: {{ loadValue[0][0] }}kN/m2</td>
        <td>L1: {{ loadValue[0][1] }}m</td>
      </tr>

      <tr>
        <td>S2: {{ loadValue[1][0] }}kN/m2</td>
        <td>L2: {{ loadValue[1][1] }}m</td>
      </tr>

      <tr>
        <td>S3: {{ loadValue[2][0] }}kN/m2</td>
        <td>L3: {{ loadValue[2][1] }}m</td>
      </tr>
    </table>

    <template slot="illustration">
      <calc-illustration which="snowAccumulation" />
    </template>
  </solution-sheet-item>
</template>

<script>
import { SolutionSheetItem, CalcIllustration } from "@/components";

export default {
  components: {
    CalcIllustration,
    SolutionSheetItem,
  },
  props: {
    loadValue: {
      required: true,
      type: Array,
    },
  },
};
</script>